
            const data = {"name":"facebook","data":{"width":"8","height":"13","viewBox":"0 0 8 13","data":"<path pid=\"0\" d=\"m7.084 7.583.35-2.133H5.25V4.065c0-.583.305-1.152 1.283-1.152h.993V1.096S6.625.952 5.763.952C3.965.952 2.79 1.974 2.79 3.824V5.45h-2v2.134h2v5.158h2.46V7.584h1.835Z\" _fill=\"#fff\"/>","originalColors":[{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                module.exports = data
                